export default "__VITE_PUBLIC_ASSET__079ea07a__"